import React, { Component } from 'react';
import globals from '../../Services/globals';
import helper from '../../Services/helper';
import { BrowserRouter as Router, Route, Link, NavLink } from "react-router-dom";

class Nav extends Component {

  state = {
    // isBoxVisible:false
    settings: {}
  };
  // toggleBox = () => {
  //   this.setState(prevState => ({ isBoxVisible: !prevState.isBoxVisible }));
  // };
  
  componentDidMount() {
    let settings = globals().getSettings(); //helper().getItemFromLocalStorage('settings')

    var promise = Promise.resolve(settings);
    let that = this
    promise.then(function(val) {
        // console.log(val);
        that.setState({
          ['settings']: val
        })
    });
  }

  
  render() {
    //const { isBoxVisible } = this.state;
      let company = globals().getLogedInUser().company;
     
      const backUrl = '/some/other/value'
      let {settings} = this.state 
      // console.log('setiii: ', settings)
    return (
      <div  >

      
      <ul style={{background: settings.style}} className={`navbar-nav bg-gradient-primary sidebar sidebar-dark accordion position-sticky top-0 left-0 bottom-0 ${this.props.toggle  ? "" : "toggled"}`} id="accordionSidebar">
      {/* Sidebar - Brand */}
      
      <a className="sidebar-brand d-flex align-items-center justify-content-center" href="#">
        {/* <div className="sidebar-brand-icon rotate-n-15">
          <i className="fas fa-laugh-wink" />
        </div> */}
                <div className="sidebar-brand-text mx-3">T3 WEB</div>
                
      </a>
      <div className="sidebar-company d-flex align-items-center justify-content-center">{ company }</div>

      {/* Divider */}
      <hr className="sidebar-divider my-0" />
      {/* Nav Item - Dashboard */}
      
      {/* <li className="nav-item">
                <a href="#/clients" className="nav-link">
          <i className="fas fa-fw fa-tachometer-alt" />
          <span>Klientët</span>
          </a>
      </li> */}
      {/* <hr className="sidebar-divider my-0" /> 
      <li className="nav-item" >
        <a className="nav-link collapsed " href="#" data-toggle="collapse"  data-target="#regsiter" aria-expanded="true" aria-controls="collapseOne">
          <i className="fas fa-fw fa-folder" />
          <span>Regjistrimet</span>
        </a>
        <div id="regsiter" className="collapse" aria-labelledby="headingOne" data-parent="#accordionSidebar">
          <div className="bg-white py-2 collapse-inner rounded">
            <a className="collapse-item" href="#/partners">
              <i className="fas fa-fw fa-handshake mr-2" />
              <span>Partnerët</span>
            </a>
            <a className="collapse-item" href="#/items#itemGoods">
              <i className="fas fa-fw fa-layer-group mr-2" />
              <span>Artikujt</span>
            </a>
            <div id="" className="collapse show" >
              <div className="bg-white py-2 collapse-inner rounded">
                <a className="collapse-item" href="#/items#itemGoods">Artikull mall</a>
                <a className="collapse-item" href="#/items#service">Shërbim</a>
                <a className="collapse-item" href="#/items#expense">Shpenzim</a>
                <a className="collapse-item" href="#/items#material">Lëndë e parë</a>
                <a className="collapse-item" href="#/items#assembled">Artikull i montuar</a>
                <a className="collapse-item" href="#/items#production">Prodhim</a>
              </div>
            </div>
            <a className="collapse-item" href="#/categories">
              <i className="fas fa-th-large fa-layer-group mr-2" />
              <span>Kategoritë</span>
            </a>
            <a className="collapse-item" href="#/units">
              <i className="fas fa-th-list fa-layer-group mr-2" />
              <span>Njësitë</span>
            </a>
          </div>
        </div>
      </li> */}
      {/* <hr className="sidebar-divider my-0" />  */}
      {/* <li className="nav-item">
      <a href="#/partners" className="nav-link">
          <i className="fas fa-fw fa-tachometer-alt" />
          <span>Partnerët</span></a>
      </li>      
      <hr className="sidebar-divider my-0" /> 
      <li className="nav-item">
      <a href="#/items" className="nav-link">
          <i className="fas fa-fw fa-tachometer-alt" />
          <span>Artikujt</span></a>
      </li>
      <hr className="sidebar-divider my-0" />  */}

      {/* <li className="nav-item" >
        <a className="nav-link collapsed " href="#" data-toggle="collapse"  data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
          <i className="fas fa-fw fa-tachometer-alt" />
          <span>Shitjet</span>
        </a>
        <div id="collapseOne" className="collapse" aria-labelledby="headingOne" data-parent="#accordionSidebar">
          <div className="bg-white py-2 collapse-inner rounded">
            <h6 className="collapse-header">Shitjet:</h6>
            <a className="collapse-item" href="#/sales">Faturat</a>
            <a className="collapse-item" href="#/sale/0/Shitje Vendore">Fature Shitje</a>
            <a className="collapse-item" href="#/sale/0/Fletdergesat">Fletdergesat</a>
            <a className="collapse-item" href="#/sale/0/Oferta">Ofertat</a>
          </div>
        </div>
      </li>

      <hr className="sidebar-divider my-0" /> */}
      {/* <li className="nav-item" >
        <a className="nav-link collapsed " href="#" data-toggle="collapse"  data-target="#collapseFinancat" aria-expanded="true" aria-controls="collapseFinancat">
          <i className="fas fa-fw fa-tachometer-alt" />
          <span>Financat</span>
        </a>
        <div id="collapseFinancat" className="collapse" aria-labelledby="headingFinancat" data-parent="#accordionSidebar">
          <div className="bg-white py-2 collapse-inner rounded">
            <h6 className="collapse-header">Financat:</h6>
            <a className="collapse-item" href="#/finances/orders">Urdhëresa Financiale</a>
            <a className="collapse-item" href="#/finances/accounting">Plani Kontabël</a>
          </div>
        </div>
      </li>

      <hr className="sidebar-divider my-0" />  */}
      {/* <li className="nav-item">
      <a href="#/items" className="nav-link">
          <i className="fas fa-fw fa-tachometer-alt" />
          <span>Blerjet</span></a>
      </li>
      <hr className="sidebar-divider my-0" /> */}
      {/* <li className="nav-item" >
        <a className="nav-link collapsed " href="#" data-toggle="collapse"  data-target="#adm" aria-expanded="true" aria-controls="collapseOne">
          <i className="fas fa-tools"></i>
          <span>Administrime</span>
        </a>
        <div id="adm" className="collapse" aria-labelledby="headingOne" data-parent="#accordionSidebar">
          <div className="bg-white py-2 collapse-inner rounded">
            <a className="collapse-item" href="#/user">
              <i className="fas fa-fw fa-user mr-2" />
              <span>Shfrytëzuesi</span>
            </a>
              <div id="" className="collapse show" >
                <div className="bg-white py-2 collapse-inner rounded">
                  <a className="collapse-item" href="#/user-configuration">Konfigurimet</a>
                </div>
              </div>
            <a className="collapse-item" href="#/cashBoxes">
              <i className="fas fa-cash-register mr-2"></i>
              <span>Arka</span>
            </a>
            <a className="collapse-item" href="#/bank">
            <i className="fas fa-money-check-alt mr-2"></i>
              <span>Banka</span>
            </a>
          </div>
        </div>
      </li>
      <hr className="sidebar-divider" /> */}
      {/* Heading */}
      {/* <div className="sidebar-heading">
        Reports
      </div> */}
      {/* Nav Item - Pages Collapse Menu */}
      <li className="nav-item">
        <a className="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
          <i className="fas fa-fw fa-cog" />
          <span>Raportet</span>
        </a>
        <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
          <div className="bg-white py-2 collapse-inner rounded">
            <h6 className="collapse-header">Stoqet:</h6>
            <a className="collapse-item" href="#/reports/warehouse">Stoku</a>
            <a className="collapse-item" href="#/reports/itemshistory">Historia e Artikujve</a>
            <hr className="sidebar-divider bg-light" />
            <h6 className="collapse-header">Librat:</h6>
            <a className="collapse-item" href="#/reports/purchasebook">Libri i Blerjes</a>
            <a className="collapse-item" href="#/reports/salesbook">Libri i Shitjes</a>
            {/* <hr className="sidebar-divider bg-light" />
            <h6 className="collapse-header">Raportet Financiare:</h6>
            <a href="#/warehouse" className="collapse-item">Libri i Kryesor</a>
            <a className="collapse-item" href="#/reports">Llogarit e Pagueshme</a>
            <a className="collapse-item" href="#/reports">Llogarit e Arktueshme</a>
            <a className="collapse-item" href="#/reports">Raporti i Arkës</a>
            <a className="collapse-item" href="#/reports">Raporti i Bankës</a>
            <h6 className="collapse-header">Librat e ATK-së:</h6>
            <a href="#/warehouse" className="collapse-item">Libri i Blerjes</a>
            <a className="collapse-item" href="#/reports">Libri i Shitjes</a> */}
          </div>
        </div>
      </li>
      {/* Nav Item - Utilities Collapse Menu */}
      {/* <li className="nav-item">
        <a className="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseUtilities" aria-expanded="true" aria-controls="collapseUtilities">
          <i className="fas fa-fw fa-wrench" />
          <span>Veglat</span>
        </a>
        <div id="collapseUtilities" className="collapse" aria-labelledby="headingUtilities" data-parent="#accordionSidebar">
          <div className="bg-white py-2 collapse-inner rounded">
                        <h6 className="collapse-header">Veglat:</h6>
                        <a className="collapse-item" href="#/">Colors</a>
                            <a className="collapse-item" href="#/">Borders</a>
                            <a className="collapse-item" href="#/">Animations</a>
                            <a className="collapse-item" href="#/">Other</a>

                        <a className="collapse-item" href="#/admin/recalculation">Rikalkulimi</a>
          </div>
        </div>
      </li> */}
      {/* Divider */}
      <hr className="sidebar-divider" />
      {/* Heading */}
      <div className="sidebar-heading">
        Addons
      </div>
      {/* Nav Item - Pages Collapse Menu */}

      {/* Nav Item - Charts */}
      <li className="nav-item">
        <a className="nav-link" href="#/charts">
          <i className="fas fa-fw fa-chart-area" />
          <span>Charts</span></a>
      </li>
      {/* Nav Item - Tables */}
      <li className="nav-item">
        <a className="nav-link" href="#/tables">
          <i className="fas fa-fw fa-table" />
          <span>Tables</span></a>
      </li>
      {/* Divider */}
      <hr className="sidebar-divider d-none d-md-block" />
      {/* Sidebar Toggler (Sidebar) */}
      <div className="text-center d-none d-md-inline">
        <button onClick={this.props.clickbtn} className="rounded-circle border-0" id="sidebarToggle" />
      </div>
    </ul>
    </div>
    );
  }
}



export default Nav;
